import { DataServer } from "../../../config.axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toggleLoading } from "../LoadingSlice";

interface InspectorListState {
  inspectorList: {
    load: boolean;
    data: [];
  };
}

export const inspectorListSlice = createSlice({
  name: "inspectorList",
  initialState: {
    inspectorList: {
      load: false,
      data: [],
    },
  } as InspectorListState,
  reducers: {},
  extraReducers: (builder: any) => {
    builder
      .addCase(fetchInspectorList.pending, (state: InspectorListState) => {
        state.inspectorList.load = true;
      })
      .addCase(fetchInspectorList.fulfilled, (state: InspectorListState, action: any) => {
        state.inspectorList.data = action.payload;
        state.inspectorList.load = false;
      })
      .addCase(fetchInspectorList.rejected, (state: InspectorListState) => {
        state.inspectorList.load = false;
      })
      .addCase(fetchTpiInspectorList.pending, (state: InspectorListState) => {
        state.inspectorList.load = true;
      })
      .addCase(fetchTpiInspectorList.fulfilled, (state: InspectorListState, action: any) => {
        state.inspectorList.data = action.payload;
        state.inspectorList.load = false;
      })
      .addCase(fetchTpiInspectorList.rejected, (state: InspectorListState) => {
        state.inspectorList.load = false;
      })
      .addCase(fetchInspectorCreatedByLoginUser.pending, (state: InspectorListState) => {
        state.inspectorList.load = true;
      })
      .addCase(fetchInspectorCreatedByLoginUser.fulfilled, (state: InspectorListState, action: any) => {
        state.inspectorList.data = action.payload;
        state.inspectorList.load = false;
      })
      .addCase(fetchInspectorCreatedByLoginUser.rejected, (state: InspectorListState) => {
        state.inspectorList.load = false;
      })
      .addCase(fetchAssinedInspectorList.pending, (state: InspectorListState) => {
        state.inspectorList.load = true;
      })
      .addCase(fetchAssinedInspectorList.fulfilled, (state: InspectorListState, action: any) => {
        state.inspectorList.data = action.payload;
        state.inspectorList.load = false;
      })
      .addCase(fetchAssinedInspectorList.rejected, (state: InspectorListState) => {
        state.inspectorList.load = false;
      });
  },
});

export default inspectorListSlice.reducer;

export const fetchInspectorList = createAsyncThunk(
  "users/fetchInspectorList",
  async (param: any, thunkAPI) => {
    try {
      thunkAPI.dispatch(toggleLoading());
      const { data } = await DataServer.get("api/getInspectorList?warehouse_id=" + param.apiParam.warehouse_id);
      thunkAPI.dispatch(toggleLoading());
      return data.data;
    } catch (error) {
      thunkAPI.dispatch(toggleLoading());
    }
  }
);

export const fetchTpiInspectorList = createAsyncThunk(
  "users/fetchTpiInspectorList",
  async (param: { apiParam: {tpi_firm_id: any, login_user_id: any } }) => {
    try {
      const { data } = await DataServer.post("api/getTpiInspectorList", {
        tpi_firm_id: param.apiParam.tpi_firm_id,
        login_user_id: param.apiParam.login_user_id
      });
      return data.data;
    } catch (error) {
    }
  }
);

export const fetchInspectorCreatedByLoginUser = createAsyncThunk(
  "users/fetchInspectorCreatedByLoginUser",
  async (param: { apiParam: {warehouse_id: any, login_user_id: any } }) => {
    try {
      const { data } = await DataServer.post("api/getInspectorCreatedByLoginUser", {
        warehouse_id: param.apiParam.warehouse_id,
        login_user_id: param.apiParam.login_user_id
      });
      return data.data;
    } catch (error) {
    }
  }
);

export const fetchAssinedInspectorList = createAsyncThunk(
  "users/fetchAssinedInspectorList",
  async (param: { apiParam: {warehouse_id: any, issue_pin: any } }) => {
    try {
      const { data } = await DataServer.post("api/getInspector", {
        warehouse_id: param.apiParam.warehouse_id,
        issue_pin: param.apiParam.issue_pin
      });
      return data.data;
    } catch (error) {
    }
  }
);